import React from 'react';
import PropTypes from 'prop-types';

import Style from './ticketCard.module.css';

export function TicketCardHeader({ children = null, className = '' }) {
    return <div className={`${Style['ticket-card-header']} ${className}`}>{children}</div>;
}

TicketCardHeader.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
};

export function TicketCardContent({ children = null, className = '', ticket = false }) {
    return <div className={`${Style['ticket-card-content']} ${ticket ? Style['ticket-card-content-ticket'] : ''} ${className}`}>{children}</div>;
}

TicketCardContent.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    ticket: PropTypes.bool
};

export function TicketCardFooter({ children = null, className = '' }) {
    return <div className={`${Style['ticket-card-footer']} ${className}`}>{children}</div>;
}

TicketCardFooter.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
};

export default function TicketCard({ children = null, className = '', ...rest }) {
    return (
        <div className={`${Style['ticket-card']} ${className}`} {...rest}>
            {children}
        </div>
    );
}

TicketCard.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
};

TicketCard.Header = TicketCardHeader;
TicketCard.Content = TicketCardContent;
TicketCard.Footer = TicketCardFooter;
